// extracted by mini-css-extract-plugin
export default {"title":"vaa-z","warning":"waa-z","sizeOptionsLegendText":"xaa-z"};